import React from "react";
import { IProduct } from "../../../classes/interfaces";
import { formatBRL } from "../../../helpers/currency.helper";
import Icon from "../../../components/ui/Icon";
import Photo from "../../../components/ui/Photo";
import { Row, Info, Title, Description, PriceRow, Price, OldPrice, ThumbWrap, AddFab } from "./ProductCard.styles";

interface ProductCardProps {
  product: IProduct;
  qty: number;
  onOpen: (product: IProduct) => void;
  /** Posição na lista, para a entrada em cascata (delay progressivo). */
  index?: number;
  /** Cardápio-vitrine (/menu): sem o botão de adicionar; o card só abre os detalhes. */
  readOnly?: boolean;
}

export default function ProductCard({ product, qty, onOpen, index, readOnly = false }: ProductCardProps) {
  const hasPromo = !!product.promotionalPrice && product.promotionalPrice > 0;

  return (
    <Row $index={index} onClick={() => onOpen(product)}>
      <Info>
        <Title>{product.name}</Title>
        {product.description && <Description>{product.description}</Description>}
        <PriceRow>
          {hasPromo && <OldPrice>de {formatBRL(product.price)}</OldPrice>}
          <Price>{formatBRL(hasPromo ? product.promotionalPrice : product.price)}</Price>
        </PriceRow>
      </Info>
      <ThumbWrap>
        <Photo src={product.imageUrl} radius={16} />
        {!readOnly && (
          <AddFab
            type="button"
            $active={qty > 0}
            aria-label={`Adicionar ${product.name}`}
            onClick={(e) => {
              e.stopPropagation();
              onOpen(product);
            }}
          >
            {qty > 0 ? qty : <Icon name="plus" size={18} strokeWidth={2.6} />}
          </AddFab>
        )}
      </ThumbWrap>
    </Row>
  );
}
